
import React from 'react'
import MailOutline from '@material-ui/icons/MailOutline'

export default function MailOutlineIcon() {

    return (
        <MailOutline />
    )
}